import React, { Component, PropTypes } from 'react';
import classNames from 'classnames';
import DropTarget from 'react-dnd/lib/DropTarget';
import Constants from 'Constants';
import { PageLayoutActions } from 'actions';
import * as SvgIcons from 'components/Material/SvgIcons';
import { hexToRgba, Units, Colors } from 'Css';
import PageLayoutOverviewColumn from './PageLayoutOverviewColumn';
import * as Icons from 'components/Icons';

const css = oxygenCss({
  root: {
    position: 'relative',
    display: 'flex',
    padding: Units.base,
    borderWidth: 2,
    borderStyle: 'dashed none dashed none',
    borderColor: 'transparent',
    '&before': {
      borderTopColor: `${hexToRgba(Colors.creen, 80)}`
    },
    '&after': {
      borderBottomColor: `${hexToRgba(Colors.creen, 80)}`
    }
  },
  dragContainer: {
    transition: 'all 0.25s ease',
    boxSizing: 'border-box',
    padding: Units.base / 2,
    flex: 1,
    '&size1': {
      flex: '1 0 100%'
    },
    '&size2': {
      flex: '1 0 50%'
    },
    '&size3': {
      flex: '1 0 33%'
    },
    '&size4': {
      flex: '1 0 25%'
    },
    '>SVG': {
      verticalAlign: 'middle'
    }
  },
  drag: {
    position: 'relative',
    textAlign: 'center',
    lineHeight: `${Units.keyline}px`,
    boxSizing: 'border-box',
    height: Units.keyline,
    cursor: 'pointer',
    border: `dashed 2px ${hexToRgba(Colors.creen, 90)}`,
    backgroundColor: `${hexToRgba(Colors.creen, 25)}`,
    opacity: 0.5,
    '>SVG': {
      verticalAlign: 'middle'
    }
  }
});

const styles = {
  icon: {
    width: Units.base * 4,
    height: Units.base * 4
  }
};
const dropTarget = {
  hover(props, monitor, component) {
    if (monitor.isOver({ shallow: true }) && component) {
      const offset = monitor.getClientOffset();
      const { y, x } = offset;
      component.checkHover(
        y,
        x,
        monitor.getItem().pageModuleId,
        monitor.getItem().pageRowId
      );
    }
  }
};

class CourseLayoutOverviewRow extends Component {
  static propTypes = {
    type: PropTypes.string,
    marked: PropTypes.string,
    pageModules: PropTypes.array,
    connectDropTarget: PropTypes.func,
    id: PropTypes.number
  };

  endDrag = item => {
    PageLayoutActions.endDragging(this.props.id, item);
  };

  checkHover = (y, x, pageModuleId, pageRowId) => {
    const { left, top, height, width } = this._node.getBoundingClientRect();
    const { id, pageModules } = this.props;
    const pageModulesWithoutDragging = pageModules.filter(
      pageModule => pageModule.id !== 'drag'
    );
    let { length: columnCount } = pageModules;
    const pageModuleIndex = pageModulesWithoutDragging.findIndex(
      pageModule => pageModule.id === pageModuleId
    );
    if (pageModuleIndex < 0) {
      columnCount++;
    }
    const xOffset = Math.max(x - left, 1);
    const dropPosition = Math.floor(columnCount * (xOffset / width));
    const pos = (y - top) / height;
    if (pos < 0.33) {
      PageLayoutActions.overRow('before', id);
    } else if (pos > 0.66) {
      PageLayoutActions.overRow('after', id);
    } else {
      if (columnCount > 3) {
        return;
      }
      // if (pageRowId === id && dropPosition === pageModuleIndex) {
      //   return;
      // }
      // console.log(pageRowId, id, dropPosition, pageModuleIndex);
      // if (pageRowId === id && dropPosition === pageModuleIndex + 1) {
      //   return;
      // }
      if (pageModuleIndex > -1 && pageModuleIndex === dropPosition) {
        if (pageRowId === id && pageModules[dropPosition].id === pageModuleId) {
          return PageLayoutActions.resetDragging();
        }
        if (
          pageRowId === id &&
          dropPosition === pageModuleIndex + 1 &&
          pageModules[dropPosition - 1].id === pageModuleId
        ) {
          return PageLayoutActions.resetDragging();
        }
        if (pageModules.length !== pageModulesWithoutDragging.length) {
          return PageLayoutActions.resetDragging();
        }
        return;
      }
      PageLayoutActions.setDraggingPos(id, dropPosition, pageModuleId);
    }
  };

  render() {
    const { pageModules, marked, id } = this.props;
    const columnCount = pageModules.length;
    const dragClasses = classNames(
      css.dragContainer,
      css[`size${columnCount}`]
    );
    const classes = classNames(css.root, {
      [css.before]: marked === 'before',
      [css.after]: marked === 'after'
    });
    const dragIndex = pageModules.findIndex(
      pageModule => pageModule.type === 'Drag'
    );
    const isDragInSameRow =
      dragIndex > -1 &&
      pageModules.findIndex(
        pageModule => pageModule.id === pageModules[dragIndex].pageModuleId
      ) > -1;
    const content = (
      <div
        ref={_node => (this._node = _node)}
        className={classes}
        onTouchTap={this.select}
      >
        {pageModules.map((pageModule, index) => {
          const { id: pageModuleId, type, ...other } = pageModule;
          if (type === 'Drag') {
            if (!isDragInSameRow) {
              const Icon =
                Icons[Constants.pageModules[pageModule.subType.name].icon];
              return (
                <div className={dragClasses} key="drag">
                  <div className={css.drag}>
                    <Icon style={styles.icon} color={Colors.creen} />
                  </div>
                </div>
              );
            }
            return null;
          }
          let columnMarked;
          if (dragIndex > -1) {
            if (index === dragIndex - 1) {
              columnMarked = 'after';
            } else if (index === dragIndex || index === dragIndex + 1) {
              columnMarked = 'before';
            } else {
              columnMarked = '';
            }
          } else {
            columnMarked = '';
          }
          return (
            <div className={dragClasses} key={pageModuleId}>
              <PageLayoutOverviewColumn
                endDrag={this.endDrag}
                onHover={this.onHover}
                id={pageModuleId}
                pageRowId={id}
                type={type}
                marked={columnMarked}
                {...other}
              />
            </div>
          );
        })}
      </div>
    );
    return this.props.connectDropTarget(content);
  }
}

export default DropTarget('CourseColumn', dropTarget, (connect, monitor) => ({
  connectDropTarget: connect.dropTarget(),
  isOver: monitor.isOver()
}))(CourseLayoutOverviewRow);



// WEBPACK FOOTER //
// ./src/js/components/Page/LayoutOverview/PageLayoutOverviewRow.js